import * as React from 'react';
import { DefaultLayout } from '../../../components/DefaultLayout';
import { Seo } from '../../../components/Seo';

import { YandexMetrika } from '../../../components/YandexMetrika';
import { MailRu } from '../../../components/MailRu';
import { TikTok } from '../../../components/TikTok';
import { VKPixel } from '../../../components/VKPixel';
import { AdvCake } from '../../../components/AdvCake';

import {
  HeroHeader,
  ProblemQuestions,
  CourseInvitation,
  CourseProgram,
  CourseTopics,
  CourseDuration,
  Registration,
} from '../../../components/LandingTemplates/angliyskaya-leksika-dlya-detey';

import { GetCourseWidget } from '../../../components/GetCourseWidget';
import { FooterFull } from '../../../components/FooterFull';

import * as registration from '../../../components//LandingTemplates/angliyskaya-leksika-dlya-detey/styles/registration.module.scss';

const TITLE = 'Английская лексика для детей — онлайн-курс Advance';
const DESCRIPTION =
  'Подходит для детей 5 классов и старше. Бесплатный курс, построенный на игровом сценарии, поможет изучить базовую английскую лексику.';
export const Head = () => (
  <Seo title={TITLE} description={DESCRIPTION}>
    <title>{TITLE}</title>
  </Seo>
);
const Page = () => (
  <DefaultLayout>
    <YandexMetrika />
    <MailRu />
    <TikTok />
    <VKPixel />
    <AdvCake />

    <main>
      <HeroHeader />
      <ProblemQuestions />
      <CourseInvitation />
      <CourseProgram />
      <CourseTopics />
      <CourseDuration />
      <Registration
        accessLimited={true}
        widget={<GetCourseWidget hash={'efb3cb9a22a385f2746b8fbacea494d396db578a'} id={'360752'} />}
      />
    </main>

    <FooterFull />
  </DefaultLayout>
);

export default Page;
